import { createFileRoute,Outlet } from '@tanstack/react-router'
import { requireCapability } from '@/lib/auth'
import { RoutePending } from '@/components/route-pending'
import { RouteError } from '@/components/route-error'

export const Route = createFileRoute('/_dashboard/devices')({
  beforeLoad: requireCapability('MANAGE_DEVICES'),
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: DevicesLayout,
})

function DevicesLayout() {
  return <Outlet />
}
